export const getCurrentPosition = () => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude: lat, longitude: lng } = position.coords;

          resolve({ lat, lng });
        },
        (error) => {
          reject(error);
        },
      );
    } else {
      reject('Geolocation not available');
    }
  });
};

const markerIcon = (
  iconColor,
) => `<svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.00013 0.316406C4.02951 0.316406 0 4.58261 0 9.84519C0 12.1946 0.806768 14.3417 2.13815 16.0031L8.26786 23.6462C8.64687 24.1188 9.35337 24.1188 9.73236 23.6462L15.8619 16.0029C17.1932 14.3417 18 12.1943 18 9.84492C18.0003 4.58261 13.9707 0.316406 9.00013 0.316406Z" fill="${iconColor}"/>
  <path d="M13.2632 9.52868C13.2632 11.9387 11.3545 13.8924 9 13.8924C6.64552 13.8924 4.73684 11.9387 4.73684 9.52868C4.73684 7.11867 6.64552 5.16497 9 5.16497C11.3545 5.16497 13.2632 7.11867 13.2632 9.52868Z" fill="white"/>
</svg>`;

const positionIcon = (
  iconColor,
) => `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <circle cx="16" cy="16" r="16" fill="${iconColor}" opacity="0.25"/>
  <circle cx="16" cy="16" r="7" fill="${iconColor}" stroke="#fff" stroke-width="2"/>
</svg>`;

export const getPositionIcon = (iconColor = '#4385f4') =>
  `data:image/svg+xml;base64,${window.btoa(positionIcon(iconColor))}`;

export const getMarkerIcon = (iconColor = 'red') =>
  `data:image/svg+xml;base64,${window.btoa(markerIcon(iconColor))}`;
